// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MainLayout_wrapper__M7zqO"};